import { NavigationEnd } from '@angular/router';

import { sanitizeUrl } from './index';

/**
 * Compares if previous and current NavigationEnd.urlAfterRedirects are equal
 * @param prevUrl
 * @param currUrl
 */
export function urlAfterRedirectsEqual(
  { urlAfterRedirects: prevUrl }: NavigationEnd,
  { urlAfterRedirects: currUrl }: NavigationEnd
): boolean {
  return sanitizeUrl(prevUrl) === sanitizeUrl(currUrl);
}
